// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2kjye","tabItems":"index_tabItems_HtgIV","tabItem":"index_tabItem_1vFkn","tabItem_active":"index_tabItem_active_2U315"};